module.exports = __webpack_public_path__ + "img/southern-union-logo.ba29b079.jpg";